export const ApiUrl =
  "https://developer-ourbase-camp.com/radiance/public/api" ||
  "http://localhost:4000";
export const ImageUrl =
  "https://developer-ourbase-camp.com/radiance/public" || "http://localhost:4000";



